import { render, staticRenderFns } from "./emailTemporary.vue?vue&type=template&id=2e59f070"
import script from "./emailTemporary.vue?vue&type=script&lang=js"
export * from "./emailTemporary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports